<template>
    <div>
        <div class="section-label">Exclusões</div>
        <EmptyState
            v-if="!item.exclusoes || item.exclusoes.length === 0"
            icon="filter"
            title="Nenhuma exclusão adicionada"
            description="Adicione exclusões usando o formulário abaixo"
        />
        <div v-else class="exclusoes-table-wrapper">
            <table class="exclusoes-table">
                <thead>
                <tr>
                    <th>#</th>
                    <th>Tipo</th>
                    <th>Valor</th>
                    <th class="text-right">Ação</th>
                </tr>
                </thead>
                <tbody>
                <tr v-for="(item, index) in item.exclusoes" :key="index">
                    <td class="td-index">{{ index + 1 }}</td>
                    <td><span class="tipo-badge">{{ item.tipo }}</span></td>
                    <td>{{ item.chave }}</td>
                    <td class="text-right">
                        <CButton
                            size="sm"
                            color="danger"
                            variant="ghost"
                            title="Remover"
                            @click="()=>remover(index)"
                        >
                            <fa-icon icon="trash-alt" />
                        </CButton>
                    </td>
                </tr>
                </tbody>
            </table>
        </div>

        <div class="section-label">Adicionar exclusão</div>
        <div class="add-exclusao-card">
            <CRow class="align-items-end">
                <CCol md="4">
                    <div class="form-group mb-0">
                        <label class="field-label">Tipo</label>
                        <select class="form-control form-control-sm" v-model="exclusao.tipo">
                            <option value="" disabled>Selecione</option>
                            <option value="FILIAL">Filial</option>
                            <option value="CLIENTE">Cliente</option>
                            <option value="REGIAO">Região (Tabela de Preço)</option>
                            <option value="REGIAO_RCA">Região (Representante)</option>
                            <option value="REDE">Rede</option>
                            <option value="PRACA">Praça</option>
                            <option value="ATIVIDADE">Atividade</option>
                            <option value="REPRESENTANTE">Representante</option>
                            <option value="SUPERVISOR">Supervisor</option>
                            <option value="UF">UF</option>
                        </select>
                    </div>
                </CCol>
                <CCol md="5">
                    <div class="form-group mb-0">
                        <label class="field-label">{{ exibeLabel }}</label>
                        <input class="form-control form-control-sm" maxlength="250" v-model="exclusao.chave" placeholder="Digite o código..." />
                    </div>
                </CCol>
                <CCol md="3">
                    <CButton
                        color="primary"
                        size="sm"
                        class="btn-adicionar"
                        :disabled="check()"
                        @click="adicionar"
                    >
                        <fa-icon icon="plus" /> Adicionar
                    </CButton>
                </CCol>
            </CRow>
        </div>
    </div>
</template>

<script>
  import _find from 'lodash/find';
  import EmptyState from "../../../components/EmptyState";

  export default {
    name: 'exclusaoCupom',
    components: { EmptyState },
    props: ['item' ],
    watch: {
      'exclusao.tipo'() {
        this.exclusao.chave = '';
      },
    },
    computed: {
      exibeLabel() {
        switch (this.exclusao.tipo) {
          case 'FILIAL':
            return 'Código filial:';
          case 'CLIENTE':
            return 'Código cliente:';
          case 'REGIAO':
            return 'Código região:';
          case 'REGIAO_RCA':
            return 'Código região:';
          case 'REDE':
            return 'Código rede:';
          case 'PRACA':
            return 'Código praça:';
          case 'ATIVIDADE':
            return 'Código atividade:';
          case 'REPRESENTANTE':
            return 'Código RCA:';
          case 'SUPERVISOR':
            return 'Código supervisor:';
          case 'UF':
            return 'Código UF:';
          default:
            return 'Código:'
        }
      },
    },
    data() {
      return {
        exclusao: {
          tipo: '',
          chave: '',
        },
      };
    },
    methods: {
      adicionar() {
        this.item.exclusoes.push({...this.exclusao});
        this.resetForm();
      },
      remover(i) {
        this.item.exclusoes.splice(i, 1);
      },
      resetForm() {
        this.exclusao.tipo = '';
        this.exclusao.chave = '';
      },
      check() {
        return _find(this.item.exclusoes, {
          tipo: this.exclusao.tipo,
          chave: this.exclusao.chave,
        }) || this.exclusao.tipo  == '' || this.exclusao.chave  == '';
      },
    },
  };
</script>

<style scoped>
.section-label {
  font-size: 11px;
  font-weight: 700;
  color: #667085;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  margin: 16px 0 10px;
  padding-top: 12px;
  border-top: 1px solid #e9ecef;
}

.section-label:first-child {
  border-top: none;
  padding-top: 0;
  margin-top: 0;
}

.field-label {
  font-size: 11px;
  font-weight: 600;
  color: #667085;
  text-transform: uppercase;
  letter-spacing: 0.3px;
  margin-bottom: 3px;
  display: block;
}

/* ===== EXCLUSÕES TABLE ===== */
.exclusoes-table-wrapper {
  border: 1px solid #e4e7eb;
  border-radius: 10px;
  overflow: hidden;
}

.exclusoes-table {
  width: 100%;
  border-collapse: collapse;
  margin: 0;
}

.exclusoes-table thead tr {
  background: #f9fafb;
  border-bottom: 1px solid #e4e7eb;
}

.exclusoes-table th {
  font-size: 11px;
  font-weight: 600;
  color: #667085;
  text-transform: uppercase;
  letter-spacing: 0.3px;
  padding: 10px 14px;
  white-space: nowrap;
}

.exclusoes-table td {
  padding: 10px 14px;
  border-bottom: 1px solid #f2f4f7;
  font-size: 13px;
  color: #344054;
  vertical-align: middle;
}

.exclusoes-table tr:last-child td {
  border-bottom: none;
}

.td-index {
  font-weight: 600;
  color: #3a3e81;
  width: 40px;
}

.tipo-badge {
  font-size: 11px;
  font-weight: 600;
  color: #3a3e81;
  background: #f2f2f8;
  padding: 3px 8px;
  border-radius: 4px;
  white-space: nowrap;
}

/* ===== ADD FORM ===== */
.add-exclusao-card {
  border: 1px solid #e4e7eb;
  border-radius: 10px;
  padding: 16px;
  background: #f9fafb;
}

.btn-adicionar {
  height: 31px;
  display: inline-flex;
  align-items: center;
  gap: 4px;
}
</style>
